import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPenFlash = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentcolor",
		fill: "none",
		id: "svg_1",
		d: "m20.06941,9.55357l-5.85322,6.84524c-0.09917,0.09917 -0.09917,0.29762 -0.09917,0.39679c0.09917,0.09929 0.19833,0.19833 0.29762,0.19833l2.57929,0l0,5.95238l5.85322,-6.84512c0.09917,-0.09917 0.09917,-0.29762 0.09917,-0.39679c-0.09917,-0.09929 -0.19833,-0.19857 -0.29762,-0.19857l-2.57929,0l0,-5.95226zm-12.61435,11.60619l-6.83006,1.78667l1.78175,-6.84893m5.04831,5.06226l-5.04831,-5.06226m5.04831,5.06226l3.33819,-3.33821m-8.3865,-1.72405l14.35313,-14.39273c1.38571,-1.38964 3.66238,-1.48891 5.14714,0c1.38583,1.38964 1.38583,3.67258 0,5.16149l-0.3894,0.38938l-5.15381,-5.15386m0.89083,6.05498l-3.46452,-3.47411",
		strokeWidth: 1.5
	}));
});
export default SvgPenFlash;
